import * as DG from 'datagrok-api/dg';
import { NOTATION } from './macromolecule/consts';
/** Class for parsing FASTA files */
export class FastaFileHandler {
    // private _columnsParsed: boolean = false;
    get descriptionsArray() { return this._descriptionsArray; }
    get sequencesArray() { return this._sequencesArray; }
    /**
     * Helper method to parse a macromolecule from a FASTA file (string)
     *
     * @param {number} startOfSequence  index of macromolecule substring beginning
     * @param {number} endOfSequence  index of macromolecule substring end
  
     * @return {string} parsed macromolecule
     */
    parseMacromolecule(startOfSequence, endOfSequence) {
        const seq = this._fileContent.slice(startOfSequence, endOfSequence);
        const seqArray = seq.split(/\s/);
        return seqArray.join('');
    }
    /** Parse descriptions and sequences from a FASTA string */
    parseColumns() {
        const regex = /^>(.*)$/gm; // match 'description' lines starting with >
        let startOfSequence = 0;
        let match; // match.index is the beginning of the matched line
        while (match = regex.exec(this._fileContent)) {
            const description = this._fileContent.substring(match.index + 1, regex.lastIndex);
            this._descriptionsArray.push(description);
            if (startOfSequence !== 0)
                this._sequencesArray.push(this.parseMacromolecule(startOfSequence, match.index));
            startOfSequence = regex.lastIndex + 1;
        }
        this._sequencesArray.push(this.parseMacromolecule(startOfSequence, -1));
        // this._columnsParsed = true;
    }
    /**
     * File-handler method for import as FASTA
     *
     * @return {DG.DataFrame[]} dataframe with parsed FASTA content
     */
    importFasta() {
        const descriptionsArrayCol = DG.Column.fromStrings('description', this.descriptionsArray);
        const sequenceCol = DG.Column.fromStrings('sequence', this.sequencesArray);
        sequenceCol.semType = DG.SEMTYPE.MACROMOLECULE;
        sequenceCol.meta.units = NOTATION.FASTA;
        return [DG.DataFrame.fromColumns([
                descriptionsArrayCol,
                sequenceCol,
            ])];
    }
    constructor(fileContent) {
        this._descriptionsArray = []; // parsed FASTA descriptions
        this._sequencesArray = []; // parsed FASTA sequeces
        this._fileContent = fileContent;
        this.parseColumns();
    }
}
//# sourceMappingURL=fasta-handler.js.map